import React, { useState } from "react";
import logo from "./__sitelogo__ProvinciaExtranet.svg";

function App() {
  const [isValidated, setIsValidated] = useState(false);
  const [hasCode, setHasCode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    const username = document.getElementById("username").value.trim();
    const email = document.getElementById("email").value.trim();

    setIsValidated(false);
    setHasCode(false);
    setIsLoading(true);
    const parameters = new URLSearchParams({ username, email });
    fetch(`/api/validateuser?${parameters}`)
      .then(async (response) => {
        const contentType = response.headers.get("content-type") || "";
        if (!contentType.includes("application/json")) {
          throw new Error("Rekisteröintipalvelu ei vastannut odotetusti. Yritä myöhemmin uudelleen.");
        }
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data?.message || "Rekisteröintitietojen tarkistus epäonnistui.");
        }
        if (data?.codeSent !== true) {
          throw new Error("Vahvistuskoodin lähettämistä ei voitu varmistaa.");
        }
        setIsValidated(true);
        setHasCode(true);
      })
      .catch((error) => {
        alert(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleHasCodeClick = () => {
    const username = document.getElementById("username").value.trim();
    const email = document.getElementById("email").value.trim();
    if (!username || !email) {
      setIsLoading(true);
      fetch(`/api/recheckuser?email=${email}`)
        .then(async (response) => {
          const data = await response.text();
          if (!response.ok) {
            throw new Error(data);
          }
          setHasCode(true);
          setIsValidated(true);
        })
        .catch((error) => {
          alert(error.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      alert("Syötä sähköpostiosoite ensin");
    }}

  const handleRegistrationSubmit = (event) => {
    event.preventDefault();
    const code = document.getElementById("code").value;
    const username = document.getElementById("username").value.trim();
    const email = document.getElementById("email").value.trim();

    setIsLoading(true);
    const parameters = new URLSearchParams({ username, email, code });
    fetch(`/api/createinvitation?${parameters}`)
      .then(async (response) => {
        const data = await response.text();
        if (!response.ok) {
          throw new Error(data);
        }
        alert("Rekisteröityminen onnistui");
        document.getElementById("registrationForm").reset();
        document.getElementById("codeForm").reset();
        setIsValidated(false);
        setHasCode(false);
      })
      .catch((error) => {
        alert(error.message);
        if (error.message.includes("Tunnus on lukittu")) {
          document.getElementById("email").disabled = true;
          document.getElementById("code").disabled = true;
          document.getElementById("codeForm").reset();
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <header>
        <img src={logo} className="header-logo" alt="" />
      </header>
      <div className="container">
        <div className="formContainer">
          <h1>Provincia asiakasextranet</h1>
          <form id="registrationForm" onSubmit={handleSubmit}>
            <label htmlFor="username">Nimi:</label>
            <input type="text" id="username" name="username" required />
            <br />
            <br />
            <label htmlFor="email">Email:</label>
            <input type="email" id="email" name="email" required />
            <br />
            <br />
            <button type="submit" disabled={isLoading} style={{ marginRight: "10px" }}>
              Lähetä
            </button>
            <button type="button" disabled={isLoading} onClick={handleHasCodeClick}>
              Onko sinulla jo koodi?
            </button>
          </form>
          {hasCode && isValidated && (
            <div id="codePopup" className="popup">
              <h2>Syötä koodi</h2>
              <form id="codeForm" onSubmit={handleRegistrationSubmit}>
                <label htmlFor="code">Koodi:</label>
                <input type="text" id="code" name="code" required />
                <br />
                <br />
                <button type="submit" disabled={isLoading}>Rekisteröidy</button>
              </form>
            </div>
          )}
          {isLoading && (
            <div className="spinner">
              <div className="loading-spinner"></div>
            </div>
          )}
        </div>
        <div className="guideBox">
          <h2>Tervetuloa Provincian asiakasextranet-palveluun!</h2>
          <p>
            Rekisteröi itsesi palveluun oheisella lomakkeella.
          </p>
          <p>
            <div>Ohje:</div>
            <div>Syötä nimesi ja sähköpostiosoitteesi. Paina "Lähetä". Saat hetken kuluttua vahvistuskoodin sähköpostiisi. Syötä koodi ja paina "Rekisteröidy".</div>
            <div>Onnistuneen rekisteröinnin jälkeen saat vielä vahvistusviestin sähköpostiisi.</div>
          </p>
          <p>    
            <div>Mikäli olet jo rekisteröitynyt aiemmin ja sinulla on koodi, jota et ole vielä syöttänyt, paina "Onko sinulla jo koodi?". Pääset syöttämään koodin ja rekisteröitymään.</div>
          </p>
          <p>
            Pian rekisteröitymisen jälkeen voit kirjautua sisään osoitteessa:
          </p>
          <p><a href="https://provinciafi.sharepoint.com/sites/asiakasextranet" target="_blank" rel="noopener noreferrer">https://provinciafi.sharepoint.com/sites/asiakasextranet</a></p>
          <p className="footer-note">
            <div>Huom:</div>
            <div>
            Rekisteröinti vaatii että organisaatiosi on kutsuttu.
            Sähköpostiosoitteen syöttämisen jälkeen oikeutesi rekisteröitymiseen
            tarkistetaan. Mikäli olet oikeutettu rekisteröitymään, sinulle
            lähetetään vahvistuskoodi sähköpostiin.
            Käyttöoikeuksien asettamisessa menee 15-60 minuuttia.
            </div>
            <div>
            Onnistuneen rekisteröitymisen jälkeen kirjautuessasi extranetiin ensimmäistä kertaa, käyttäjän on lisättävä kaksivaiheinen tunnistautuminen esimerkiksi
            puhelinnumeron tai Microsoft Authenticatorin avulla. Vanhan extranetin varmenne ei ole käytössä uudessa ympäristössä.
            </div>
          </p>
        </div>
      </div>
    </>
  );
}

export default App;
